import React from 'react';
import { choose } from '../../utils/platform';
import { useServiceDetail } from './useServiceDetail';
import ServiceDetailDesktop from './ServiceDetail.desktop';
import ServiceDetailMobile from './ServiceDetail.mobile';

const ServiceDetailView = choose(ServiceDetailDesktop, ServiceDetailMobile);

// /app/services/:serviceId — the menu/jobs and payments of one engagement.
export default function ServiceDetail() {
  const vm = useServiceDetail();
  return <ServiceDetailView vm={vm} />;
}
